import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.MainComponent,
    {
      tag: "component",
      attrs: { width: _setup.isMobile ? undefined : 360 },
      model: {
        value: _setup.isVisible,
        callback: function ($$v) {
          _setup.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c(VCard, { staticClass: "text--text" }, [
        !_setup.isMobile
          ? _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-center px-6 py-4" },
                  [
                    _c(
                      VIcon,
                      {
                        staticClass: "mr-6",
                        attrs: { color: "icon-secondary", size: "24" },
                        on: {
                          click: function ($event) {
                            _setup.isVisible = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          ui-icon-close-not-a-circle\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-h6 text--text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.t(_setup.title, _setup.l10nOptions)) +
                          "\n        "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(VDivider),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "px-4", class: [_setup.isMobile ? "py-6" : "py-4"] },
          [
            _setup.isMobile
              ? _c(
                  "div",
                  { staticClass: "d-flex align-center mb-2" },
                  [
                    !_setup.documents.fakeDocuments
                      ? _c(
                          VIcon,
                          { attrs: { color: "success", size: "24" } },
                          [
                            _vm._v(
                              "\n          ui-icon-shield-checkmark-40\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-h6",
                        class: _setup.documents.fakeDocuments
                          ? "text--text"
                          : "text-success--text ml-4",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t(_setup.title, _setup.l10nOptions)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-body-1 text-secondary--text mb-2" },
              [
                _setup.documents.fakeDocuments
                  ? [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _setup.t(
                              "Мы отправили запрос в ответственное учреждение и получили ответ, что документ не выдавался:",
                              _setup.l10nOptions
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  : _setup.isTypeLicense
                  ? [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _setup.t("Лицензия клиники:", _setup.l10nOptions)
                          ) +
                          "\n          "
                      ),
                      _c("br"),
                      _vm._v(
                        _vm._s(_setup.documents.licenseNumber) + "\n        "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _setup.t(
                              "Специалист предоставил документы, а мы проверили их достоверность",
                              _setup.l10nOptions
                            )
                          ) +
                          "\n        "
                      ),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _setup.documents.fakeDocuments
              ? _vm._l(
                  _setup.documents.fakeDocuments,
                  function (fakeDocument, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "d-flex py-3" },
                      [
                        _c(
                          VIcon,
                          { attrs: { color: "text-error", size: "24" } },
                          [
                            _vm._v(
                              "\n            ui-icon-circle-warning\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-body-1 ml-4" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _setup.t?.(fakeDocument, _setup.l10nOptions) ||
                                  fakeDocument
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    )
                  }
                )
              : [
                  _setup.documents.isEducationConfirmed
                    ? _c(
                        "div",
                        { staticClass: "d-flex py-3" },
                        [
                          _c(
                            VIcon,
                            { attrs: { color: "text-success", size: "24" } },
                            [
                              _vm._v(
                                "\n            ui-icon-check-circle\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-body-1 ml-4" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _setup.t(
                                    "Диплом о базовом образовании",
                                    _setup.l10nOptions
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.documents.isCategoryConfirmed
                    ? _c(
                        "div",
                        { staticClass: "d-flex py-2" },
                        [
                          _setup.documents.isCategoryValid &&
                          !_setup.documents.isCategoryExpiringSoon
                            ? _c(
                                VIcon,
                                {
                                  attrs: { color: "text-success", size: "24" },
                                },
                                [
                                  _vm._v(
                                    "\n            ui-icon-check-circle\n          "
                                  ),
                                ]
                              )
                            : _c(
                                VIcon,
                                { attrs: { color: "text-error", size: "24" } },
                                [
                                  _vm._v(
                                    "\n            ui-icon-circle-warning\n          "
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-4" }, [
                            _c("div", { staticClass: "text-body-1" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _setup.t(
                                      "Удостоверение о категории",
                                      _setup.l10nOptions
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            !_setup.documents.isCategoryValid
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-body-2 text-error--text",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _setup.t(
                                            "Документ уже недействителен",
                                            _setup.l10nOptions
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _setup.documents.categoryExpiresDate
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-body-2",
                                    class: _setup.documents
                                      .isCategoryExpiringSoon
                                      ? "text-error--text"
                                      : "text-secondary--text",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _setup.t(
                                            "Действительно до",
                                            _setup.l10nOptions
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _setup.categoryExpiresDateFormatted
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.documents.isScienceConfirmed
                    ? _c(
                        "div",
                        { staticClass: "d-flex py-3" },
                        [
                          _c(
                            VIcon,
                            { attrs: { color: "text-success", size: "24" } },
                            [
                              _vm._v(
                                "\n            ui-icon-check-circle\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-body-1 ml-4" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_setup.translatedScienceText) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
            _vm._v(" "),
            _c(
              VBtn,
              {
                staticClass:
                  "primary--text mt-3 branding-btn branding-btn--background",
                attrs: { color: "bg-primary", depressed: "", block: "" },
                on: { click: _setup.handleClickButton },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_setup.documentButtonText) + "\n      "
                ),
              ]
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }